export enum RoleEnum {
    Admin = 'admin',
    CompanyAdmin = 'company admin',
    Maintainer = 'maintainer',
    User = 'user'
};